import { createRouter, createWebHistory } from "vue-router"

import { useSessionStore } from "@/stores/userSession.js"

const Account = () => import("@/views/Account.vue")

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    return { left: 0, top: 0 }
  },
  routes: [
    { path: "/", name: "empty", component: () => import("@/views/Empty.vue") },
    { path: "/login", name: "login", component: () => import("@/views/Login.vue") },
    { path: "/signup", name: "signup", component: () => import("@/views/Signup.vue") },
    {
      path: "/reset-password/:tokenGuid",
      name: "reset-password",
      component: () => import("@/views/ResetPassword.vue")
    },
    {
      path: "/create-account/:tokenGuid",
      name: "create-account",
      component: () => import("@/views/CreateAccount.vue")
    },
    { path: "/account", name: "account", component: Account },
    { path: "/docs", name: "docs", component: Account },
    { path: "/download", name: "download", component: Account },
    {
      path: "/map-widget/:authToken?",
      name: "mapWidget",
      component: () => import("@/views/MapWidget.vue")
    }
  ]
})

router.beforeEach((to) => {
  const sessionStore = useSessionStore()
  const isLogged = sessionStore.session != null
  // The root path only shows a logo, so send visitors where they belong.
  if (to.name === "empty") {
    return { name: isLogged ? "account" : "login" }
  }
  if (!isLogged && ["account", "docs", "download"].includes(to.name)) {
    return { name: "login" }
  }
  return true
})

export default router
